import { CalendarView, Row } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { RowType } from "PFApp/booking/types/row";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { WorkforceItem } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";

export const SECONDARY_TEXT_DELIMITER = " · ";

export const checkIsLastLevel = (calendarRoot: CalendarRoot, { type }: Row) => {
  switch (calendarRoot) {
    case CalendarRoot.WorkforceProfiles:
      return type !== RowType.Profile;
    case CalendarRoot.ProjectsEngagements:
    case CalendarRoot.ProjectsRoles:
      return type === RowType.Profile;
  }
};

export const checkIsExpandable = (
  calendarRoot: CalendarRoot,
  row: Row,
  view: CalendarView | null
): boolean => {
  const { type, original } = row;
  if (isWorkforceProfiles(calendarRoot)) {
    if (type !== RowType.Profile || view === CalendarView.BookingsOnly) {
      return false;
    }
    const { profile } = original as WorkforceItem;
    return profile.hasBookings;
  } else {
    const isLastLevel = checkIsLastLevel(calendarRoot, row);
    if (isLastLevel) {
      return false;
    }
    const { activity } = original as ProjectItem;
    return !!activity?.childrenWorkflowStatesTally || activity?.hasBookings;
  }
};
